import { BaseDto } from './base-dto';

export class TodasLasCita extends BaseDto {
    public fechaFormat!:Date;
    public total!:number;
 } 
